import { dataPhoneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhoneSolid = /*#__PURE__*/createIcon(dataPhoneSolid)
export default IconPhoneSolid
